import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function WhyNothingWorked() {
  const comparisons = [{
    bad: 'Tratan síntomas',
    good: 'Trabaja la raíz: el sistema nervioso'
  }, {
    bad: 'Requieren fuerza de voluntad',
    good: 'Reprograma respuestas automáticas'
  }, {
    bad: 'Resultados temporales',
    good: 'Cambio sostenible en 30 días'
  }, {
    bad: 'Genéricas para todos',
    good: 'Protocolo personalizado'
  }];
  return <section className="py-20 px-4 bg-white relative" data-id="element-306">
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none rotate-180" data-id="element-307">
        <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-308">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#E8E0D5" data-id="element-309"></path>
        </svg>
      </div>

      <div className="max-w-4xl mx-auto pt-10" data-id="element-310">
        <div className="text-center mb-16" data-id="element-311">
          <img src="https://cdn.magicpatterns.com/uploads/2Pt7n5E9Uc2M8qqJot5nqV/1_-_copia.png" alt="Antes y después: 30 días pueden cambiar cómo te sientes por dentro" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg mb-8 border border-sage/20" data-id="element-312" />
          <h2 className="font-display font-bold text-3xl md:text-4xl text-teal mb-4" data-id="element-313">
            No fallaste tú. Falló el enfoque.
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-xl border border-sage/20 overflow-hidden" data-id="element-314">
          <div className="grid grid-cols-2 bg-beige-dark/30 border-b border-sage/20" data-id="element-315">
            <div className="p-3 md:p-6 text-center font-heading font-bold text-neutral-gray text-xs sm:text-sm md:text-base break-words" data-id="element-316">
              Soluciones superficiales ❌
            </div>
            <div className="p-3 md:p-6 text-center font-heading font-bold text-teal bg-sage/20 text-xs sm:text-sm md:text-base break-words" data-id="element-317">
              MÉTODO R.E.S.T.A.U.R.A™ ✅
            </div>
          </div>

          <div className="divide-y divide-sage/10" data-id="element-318">
            {comparisons.map((row, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="grid grid-cols-2" data-id="element-319">
                <div className="p-4 md:p-6 flex items-center justify-center text-center text-neutral-gray text-xs sm:text-sm md:text-base break-words" data-id="element-320">
                  {row.bad}
                </div>
                <div className="p-4 md:p-6 flex items-center justify-center text-center text-teal font-medium bg-sage/5 text-xs sm:text-sm md:text-base break-words" data-id="element-321">
                  {row.good}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}